<template>
    <transition
        name="o-anim-fade-300"
        mode="out-in"
        appear>
        <slot></slot>
    </transition>
</template>
